// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LWGI","content":"styles_content__2cIh_"};